import React, { createContext, useCallback, useMemo, useState } from "react";
export const StepsContext = createContext(null);
export const StepsProvider = ({ children = void 0 }) => {
  const [currentStep, setCurrentStep] = useState("authorize");
  const [enabledSteps, enableStep] = useState(["authorize"]);
  const [availableSteps, setAvailableStep] = useState([]);
  const isDisabledStep = useCallback(
    (step) => {
      if (!enabledSteps || enabledSteps.length === 0) {
        return true;
      }
      return !enabledSteps.includes(step);
    },
    [enabledSteps]
  );
  const setEnabledStep = useCallback(
    (step) => {
      enableStep([...enabledSteps, step]);
    },
    [enabledSteps]
  );
  const stepContextProviderValue = useMemo(
    () => ({
      availableSteps,
      currentStep,
      enabledSteps,
      isDisabledStep,
      setAvailableStep,
      setCurrentStep,
      setEnabledStep
    }),
    [availableSteps, currentStep, enabledSteps, isDisabledStep, setEnabledStep]
  );
  return /* @__PURE__ */ React.createElement(StepsContext.Provider, { value: stepContextProviderValue }, children);
};
